import { useRouter } from 'next/router';
import Head from 'next/head';
import Navbar from 'components/molecules/Navbar';
import Sidebar from 'components/organisms/Sidebar';

const Home = () => {
  const router = useRouter();

  return (
    <div>
      <Head>
        <title>Dalenta-hub</title>
        <meta name='description' content='Generated by create next app' />
        <link rel='icon' href='/favicon.ico' />
      </Head>

      <Navbar />

      <main className='flex w-full'>
        <Sidebar />
        <div style={{ width: '75%' }} className='pt-24 px-5'></div>
      </main>
    </div>
  );
};

export default Home;
